<template>
	<card>
		<div class="container-fluid" style="min-height: 650px;">
			<div class="row">
				<div class="col-sm-12">
					<h5 class="back-title" @click="back()"><i class="fa fa-angle-left"></i> Back To Previous Page </h5>
				</div>
			</div>
			<div class="row pt-5 mt-5" v-if="channel">
				<div class="col-xl-6 offset-xl-4">
					<!-- <div class="row pt-2">
						<div class="col-xl-3">
							<label class="site-name">Add CT </label>
						</div>
						<div class="col-xl-3">
							<select class="channel-input">
								<option v-for="ct in CTS"> {{ ct }} </option>
							</select>
						</div>
					</div> -->
					<div class="row pt-2">
						<div class="col-xl-3">
							<label class="site-name">Rename </label>
						</div>
						<div class="col-xl-3">
							<input type="text" class="channel-input" v-model="channel.device_name"/>
						</div>
					</div>
					<div class="row pt-2">
						<div class="col-xl-3">
							<label class="site-name">Device Type </label>
						</div>
						<div class="col-xl-3">
							<select class="channel-input" v-model="channel.device_type"  @change="changeType()">
								<option v-for="type in types" :value="type.id" :key="type.id"> {{ type.device_type_name }} </option>
							</select>
						</div>
					</div>
					<div class="row pt-2">
						<div class="col-xl-3">
							<label class="site-name">Size </label>
						</div>
						<div class="col-xl-3">
							<input type="text" class="channel-input" />
						</div>
					</div>
					<div class="row pt-2">
						<div class="col-xl-3">
							<label class="site-name">Order </label>
						</div>
						<div class="col-xl-3">
							<input type="text" class="channel-input" v-model="channel.device_order"/>
						</div>
					</div>
					<div class="row pt-2">
						<div class="col-xl-3">
							<label class="site-name">Unit </label>
						</div>
						<div class="col-xl-3">
							<input type="text" class="channel-input" v-model="channel.device_unit"/>
						</div>
					</div>
					<div class="row pt-2">
						<div class="col-xl-3">
							<label class="site-name">Multiplier </label>
						</div>
						<div class="col-xl-3">
							<input type="text" class="channel-input" v-model="channel.multiplier"/>
						</div>
					</div>
					<div class="row pt-2">
						<div class="col-xl-3">
							<label class="site-name">Show Graph </label>
						</div>
						<div class="col-xl-3">
							<select class="channel-input" v-model="channel.dashboard">
								<option value="1"> yes </option>
								<option value="0"> no </option>
							</select>
						</div>
					</div>
					<div class="row pt-2">
						<div class="col-xl-3">
							<label class="site-name">Set Applience </label>
						</div>
						<div class="col-xl-3">
							<select class="channel-input" v-model="channel.applience">
								<option value="1"> yes </option>
								<option value="0"> no </option>
							</select>
						</div>
					</div>
					<div class="row pt-2">
						<div class="col-xl-3">
							<label class="site-name">Set Overall </label>
						</div>
						<div class="col-xl-3">
							<select class="channel-input" v-model="channel.overall">
								<option value="1"> yes </option>
								<option value="0"> no </option>
							</select>
						</div>
					</div>
				</div>
				<div class="col-sm-6 offset-xl-4 pt-4">
					<button type="button" class="edit-channel" @click="updateChannel()">
						<i class="fa fa-plus"></i>
						Update Channel
					</button>
				</div>
			</div>
			<div class="row">
				<div class="col-xl-6 offset-xl-4">
					<div class="col-sm-6 pt-4 pl-0">
						<button type="button" class="edit-channel" @click="showAddApplience=!showAddApplience">
							<i class="fa fa-plus"></i>
							Add Applience
						</button>
					</div>
				</div>
				<div class="col-sm-6 offset-xl-4 pt-4 applience-form-input" v-show="showAddApplience">
					<div class="row" style="align-items: end !important;">
						<div class="col-sm-6">
							<div class="form-input row">
								<div class="name-input col-sm-6">
									<label for="name" class="t-title">Name:&nbsp;</label>
									<input id="name" type="text" v-model="applience.name" class="site-input" />
								</div>
								<div class="name-input col-sm-6">
									<label for="make" class="t-title">Make:&nbsp;</label>
									<input id="make" type="text" v-model="applience.make" class="site-input" />
								</div>
							</div>
							
						</div>
						<div class="col-xl-6 col-sm-6">
							<button class="submit-button" @click="showAddApplience=false">Cancel</button>
							<button class="submit-button" @click="addApplience()">
								<i class="fa fa-plus"></i>
								Add Applience
							</button>
						</div>
					</div>
					<div class="row">
						<div v-if="errorMessages.length > 0"  class="row form-group pl-5 pr-5 mb-5" style="justify-content: center;text-align: left;">
							<p v-for="error in errorMessages" style="color: #8D448B !important; display: block;">
								{{ error }}
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row" v-if="appliences.length > 0">
				<div class="col-sm-6 offset-xl-4 pt-4">
					<table>
						<thead>
							<tr>
								<th>Name</th>
								<th>Make</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="applience in appliences">
								<td>{{ applience['name'] }}</td>
								<td>{{ applience['make'] }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</card>
</template>

<script>
import Card from "@/components/Cards/Card";
import { mapActions, mapGetters } from "vuex";
export default {
	name: 'Edit-channel',
	components: {
		Card
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			user: 'auth/getUser'
		})
	},
	data() {
		return {
			sites: [],
			errorMessages: [],
			appliences: [],
			CTS: [
				'D6F00034F12A8_CT1',
				'D6F00034F12A8_CT4',
				'D6F00034F12A8_CT4',
				'D6F00034F12A8_CT7',
				'D6F00034F12A8_CT8',
				'D6F00034F12A8_CT9',
				'D6F00034F12A8_CT10',
				'D6F00034F12A8_CT11',
				'D6F00034F12A8_CT12',
				'D6F00034F12A8_CT13',
				'D6F00034F12A8_CT14',
				'D6F00034F12A8_CT15',
				'D6F00034F12A8_CT16',
				'D6F00034F12A8_CT17',
				'D6F00034F12A8_CT19',
				'D6F00034F12A8_CT20',
				'D6F00034F12A8_CT21',
				'D6F00034F12A8_CT22',
				'D6F00034F12A8_CT23',
				'D6F00034F12A8_CT24',
				'D6F00034F12A8_CT25',
				'D6F00034F12A8_CT26',
				'D6F00034F12A8_CT27',
				'D6F00034F12A8_CT28',
				'D6F00034F12A8_CT29',
			],
			showAddApplience: false,
			applience: {
				device_id: null,
				name: '',
				make: ''
			},
			types: [],
			units: ['Wh', 'kWh', 'Hz', 'V', 'm3', 'ltr', '%', 'Lux', 'Â° Celcius', 'Pulse'],
			channel: null
		}
	},
	async created() {
		this.channel = await this.getChannel(this.$route.params.id);
		this.sites = await this.getSites(this.user.id);
		this.appliences = await this.getAppliences(this.channel.id);
		console.log(this.channel.id);
		console.log(this.appliences);
		this.types = await this.getTypes();
		this.changeType();
	},
	methods: {
		...mapActions({
			getTypes: "admin/getDeviceTypes",
			updateDevice: "admin/updateDevice",
			getSites: "admin/getSites",
			setUserSite: "auth/setUserSites",
			addAdminApplience: "admin/addApplience",
			getAppliences: "admin/getAppliences",
			getChannel: "admin/getChannel"
		}),
		back() {
			this.$router.go(-1)
		},
		changeType() {
			let item = this.types.find(i => i.id == this.channel.device_type);
			if (item) this.channel.device_unit =  item.unit;
		},
		async updateChannel() {
			let site = this.sites.find(i => i.sitename === this.user.site)
			Object.assign(site, {userId: this.user.id});
			await this.updateDevice(this.channel);
			this.$toasted.show("Channel is updated successfully", {
				type: "success",
				duration: 2500,
			});
			await this.setUserSite(site)
		},
		async addApplience() {
			if (this.applience.name == '') {
				this.errorMessages.push("Please input applience name");
			}

			if (this.applience.make == '') {
				this.errorMessages.push("please input applience make");
			}

			if (this.errorMessages.length == 0) {
				this.applience.device_id = this.channel.id;
				const response = await this.addAdminApplience(this.applience);

				if (response.length == 0) {
					this.$toasted.show("Applience is added successfully", {
						type: "success",
						duration: 2500,
					});
					this.showAddApplience = false;

					this.appliences.push(this.applience);
					this.applience = {
						device_id: null,
						name: '',
						make: ''
					}
				} else {
					this.$toasted.show(response.message, {
						type: "error",
						duration: 2500,
					});
					this.applience = {
						device_id: null,
						name: '',
						make: ''
					}
				}
			}
		}
	},
}
</script>

<style lang="scss" scoped>
.back-title {
	color: #4fcf8d;
	cursor: pointer;

	&:hover {
		color: #4fcf00;
		opacity: 0.8;
	}
}

.applience-form-input {
	.t-title {
		color: white;
		display: block;
		line-height: 15px;
	}	
}
.site-name {
	color: white;
	font-family: "Nunito Sans Light";
	font-weight: 100;
}
.edit-channel {
	width: 140px;
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	z-index: 8;
	font-size: 14px;
	font-family: 'Nunito Sans Light';
	border-radius: 2px;
	&:hover {
		background-color: #1f5881;
	}
}

.channel-input {
	width: 160px;
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	border-radius: 4px;
	color: white;
}

.gateway-channel {
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	z-index: 8;
	font-size: 14px;
	font-family: 'Nunito Sans Light';
	border-radius: 2px;
	&:hover {
		background-color: #1f5881;
	}
}

table{
  border-collapse: collapse;
  width: 100%;
}

th, td {
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #6258eb;
}

th {
  background-color: #192442;
  color: white;
}

</style>
